import { Route, Routes } from 'react-router-dom';

import { MembershipRedirectFinalPage } from '../../pages/post-checkout/redirectPages/MembershipRedirectFinalPage';
import { MembershipRedirectPage } from '../../pages/post-checkout/redirectPages/MembershipRedirectPage';
import { ReceiptRedirectPage } from '../../pages/post-checkout/redirectPages/ReceiptRedirectPage';
import { ShopToGiveRedirectPage } from '../../pages/post-checkout/redirectPages/ShopToGiveRedirectPage';
import { POSReceiptLandingPage } from '../../pages/post-checkout/redirectPages/pos/POSReceiptLandingPage';
import { PostCheckoutRedirectLayout } from '../Layouts/PostCheckoutRedirectLayout';

const PostCheckoutRedirectRoutes = () => {
  return (
    <Routes>
      <Route element={<PostCheckoutRedirectLayout />}>
        <Route path="membership" element={<MembershipRedirectFinalPage />} />
        <Route path="membership-with-stg" element={<MembershipRedirectPage />} />
        <Route path="membership-without-stg" element={<MembershipRedirectPage />} />
        <Route path="stg" element={<ShopToGiveRedirectPage />} />
        <Route path="receipt" element={<ReceiptRedirectPage />} />
        <Route path="pos-receipt" element={<POSReceiptLandingPage />} />
      </Route>
    </Routes>
  );
};

export { PostCheckoutRedirectRoutes };
